import React from 'react';
import { cx } from '../../utils/cx.js';

// Deterministic palette shared with Insights' CardSelect: a name always gets the same color.
const AVATAR_COLORS = [
  { bg: '#ece8fd', fg: '#5b3df0' },
  { bg: '#ffe9d6', fg: '#c2410c' },
  { bg: '#dcf5e6', fg: '#15784c' },
  { bg: '#e0f0ff', fg: '#2f6df0' },
  { bg: '#fde8f0', fg: '#be185d' },
  { bg: '#fef3c7', fg: '#b45309' },
];

export const avatarColor = (text = '') => {
  const sum = [...String(text)].reduce((acc, c) => acc + c.charCodeAt(0), 0);
  return AVATAR_COLORS[sum % AVATAR_COLORS.length];
};

const initialOf = (text = '') => {
  // Skip leading punctuation/emoji so "#général" or "(Démo)" still get a letter.
  const letter = String(text).trim().match(/[\p{L}\p{N}]/u);
  return (letter ? letter[0] : '?').toUpperCase();
};

const SIZES = {
  xs: 'h-6 w-6 text-[11px]',
  sm: 'h-7 w-7 text-xs',
  md: 'h-9 w-9 text-sm',
  lg: 'h-11 w-11 text-base',
};

/** Initial on a deterministic tint. `round` for people, squared (Insights projects) otherwise. */
const Avatar = ({ text, size = 'md', round = false, className = '' }) => {
  const { bg, fg } = avatarColor(text || '');
  return (
    <span
      className={cx('inline-flex flex-shrink-0 items-center justify-center font-bold', round ? 'rounded-full' : 'rounded-lg', SIZES[size] || SIZES.md, className)}
      style={{ background: bg, color: fg }}
      aria-hidden
    >
      {initialOf(text)}
    </span>
  );
};

export default Avatar;
